import { Row } from '@tanstack/react-table';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { notificationRuleBaseSchema } from '@/features/notification-rules/schemas/notification-rules.schema.ts';
import { DotsHorizontalIcon } from '@radix-ui/react-icons';
import { NotificationRulesTableRowActionEditDialog } from '@/features/notification-rules/components/notification-rules-table/notification-rules-table-row-action-edit-dialog.tsx';
import NotificationRulesTableRowActionDeleteDialog from '@/features/notification-rules/components/notification-rules-table/notification-rules-table-row-action-delete-dialog.tsx';

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function NotificationRulesTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const notificationRule = notificationRuleBaseSchema.parse(row.original);

  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="data-[state=open]:bg-muted flex h-8 w-8 p-0 hover:bg-gray-200"
          >
            <DotsHorizontalIcon className="h-5 w-5" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          <DropdownMenuItem asChild>
            <NotificationRulesTableRowActionEditDialog notificationRule={notificationRule} />
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <NotificationRulesTableRowActionDeleteDialog notificationRule={notificationRule} />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
